// React and related imports
import React from 'react';

// Flowbite components
import { Label, Radio } from 'flowbite-react';

// Types and Enums
import { ContentContextTypes } from '../../common/enums/ContentContextTypes';
import { ContextState } from '../../hooks/useContentContextState';

// i18n translation
import { TFunction } from 'i18next';

interface ContentContextTypeSwitchProps {
  t: TFunction<'translation', undefined>;
  contextState: ContextState;
  updateField: (field: keyof ContextState, value: string) => void;
}

export const ContentContextTypeSwitch: React.FC<
  ContentContextTypeSwitchProps
> = ({ t, contextState, updateField }) => {
  const handleOptionChange = (value: string) => {
    updateField('type' as keyof ContextState, value);
  };

  return (
    <>
      <div className="mb-2 block">
        <Label
          htmlFor="contentContextType"
          value={t('contentContext.selectContextType')}
        />
      </div>
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <Radio
            id="generic"
            name="contentContextType"
            value={ContentContextTypes.GENERIC}
            checked={contextState?.type === ContentContextTypes.GENERIC}
            onChange={(e) => handleOptionChange(e.target.value)}
          />
          <Label htmlFor="generic">{t(`contentContextTypes.GENERIC`)}</Label>
        </div>
        <div className="flex items-center gap-2">
          <Radio
            id="content-engagement"
            name="contentContextType"
            value={ContentContextTypes.CONTENT_ENGAGEMENT}
            checked={
              contextState?.type === ContentContextTypes.CONTENT_ENGAGEMENT
            }
            onChange={(e) => handleOptionChange(e.target.value)}
          />
          <Label htmlFor="content-engagement">
            {t(`contentContextTypes.CONTENT_ENGAGEMENT`)}
          </Label>
        </div>
      </div>
    </>
  );
};
